export default __webpack_public_path__ + "static/media/srivalli.5a8cc947.jpg";